import React from 'react'

import './_modal.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import CloseButton from '../close-button'

type Props = Overwrite<
  CommonProps<'section'>,
  {
    size?: 'default' | 'xl' | 'l' | 's'
    children?: React.ReactNode
    headline?: React.ReactNode
    buttons?: React.ReactNode
    footerContent?: React.ReactNode
    scrollContainerId?: string
    fullscreenMobile?: boolean
    onClose?: React.MouseEventHandler
  }
>

const Modal = ({
  size = 'default',
  className,
  children,
  headline,
  scrollContainerId,
  buttons,
  footerContent,
  fullscreenMobile = false,
  onClose,
  ...props
}: Props) => (
  <section
    {...props}
    className={cn(
      'Modal',
      {
        [`size-${size}`]: true,
        buttons: !!buttons,
        fullscreenMobile,
        noHeadline: !headline,
      },
      className
    )}
  >
    <header className="Modal__header">
      <div className="Modal__headline">
        {headline}
        {onClose && <CloseButton onClick={onClose} />}
      </div>
    </header>
    <div className="Modal__content" id={scrollContainerId}>
      {children}
    </div>
    {(!!buttons || !!footerContent) && (
      <footer className="Modal__footer">
        {footerContent && <div className="Modal__footerContent">{footerContent}</div>}
        {buttons && <div className="Modal__footerButtons">{buttons}</div>}
      </footer>
    )}
  </section>
)

export default Modal
